<template>
  <div :style="{paddingTop: '1rem !important'}">
    <v-btn
      class="back"
      dark
      icon
      @click="historyBack"
    >
      <v-icon
      :style="{color: '#27846d !important', fontSize: '34px'}"
      >
        icon-ayudadigital-volver
      </v-icon>
    </v-btn>

    <div class="loading" v-if="loading">
      <v-progress-circular
        color="teal"
        :size="200"
        indeterminate
        :width="10"
      ><div>Cargando mapa</div></v-progress-circular>
    </div>
    <div class="containerMap">
      <iframe class="map" id="mapa" v-show="!loading"></iframe>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  props: {
    id: {
      type: String,
      required: false,
      default: null,
    },
    idNodo: {
      type: String,
      required: false,
      default: null,
    },
  },
  computed: {
    ...mapState({
      user: ({ session: { session } }) => (session != null ? session.user : null),
    }),
    code() {
      return localStorage.getItem('from') === '/pulsodigital/incidenciasproactivas'
        ? 'PROACTIVAS_SANDETEL'
        : 'PULSO_DIGITAL';
    },
  },
  data() {
    return {
      loading: false,
      map: null,
    };
  },
  methods: {
    async getMap() {
      this.loading = true;

      let endpoint = `cges/global/mapas?codigo=${this.code}`;

      if (this.idNodo !== null) {
        endpoint += `&idNodo=${this.idNodo}`;
      }

      let capasVisibles = '';

      if (this.id !== null) {
        capasVisibles = `&capasVisibles=${this.id}`;
      }

      const { userid } = this.$store.getters['session/user'];
      const res = await this.$api.getClient('solicitudes').getMap({
        apiCges: {
          delegado: userid,
          endpoint: `${endpoint}${capasVisibles}`,
        },
      });
      this.loading = false;
      const mapaString = res.data;
      const s = document.getElementById('mapa');
      s.contentDocument.write(mapaString.toString().replaceAll('http://mapea4-sigc.juntadeandalucia.es', 'https://mapea4-sigc.juntadeandalucia.es'));
    },
    historyBack() {
      window.history.back();
    },
    isUserTic() {
      const user = this.$store.getters['session/user'];
      return user.accessTypeTic;
    },
    isCitizen() {
      return this.user.hasIosUser();
    },
  },
  async created() {
    if (!this.isUserTic() || this.isCitizen()) {
      this.$store.dispatch('messages/createNotificationMessage', {
        title: 'No tienes permiso para visualizar esta funcionalidad',
        type: 'error',
        timeout: this.$getConst('notifications.timeoutPlus'),
        dismissible: true,
      });

      if (this.isCitizen()) {
        this.$router.push('/');
      } else {
        this.$router.push('/pulsodigital');
      }
    } else {
      await this.getMap();
    }
  },
};
</script>

<style scoped>
.containerMap {
  text-align: center;
}

.map {
  width: 85vw;
  height: 75vh;
  border: 1px solid black;
}

.back:hover {
  color: #27846d !important;
  caret-color: #27846d !important;
}

@media screen and (min-width: 900px) {
  .back {
    margin-left: 85px;
  }
}

@media screen and (min-height: 800px) {
  .loading {
    text-align: center;
    margin-top: 250px;
  }
}

@media screen and (max-height: 800px) {
  .loading {
    text-align: center;
    margin-top: 140px;
  }
}

</style>
